// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { randomString } from '@med/app/home/campaigns/testing/random';
import { SpinnerService } from '@med/app/core/services/spinner.service';

@Component({
  selector: 'e-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent implements OnChanges {
  @Input() show: boolean;
  name = randomString(20);

  constructor(
    private spinnerService: SpinnerService,
  ) {
  }

  ngOnChanges(): void {
    if (this.show) {
      this.spinnerService.show(this.name);
    } else {
      this.spinnerService.hide(this.name);
    }
  }

}
